import { useLang } from "../contexts/LanguageContext";

export function AboutSection() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-background"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="tracking-eyebrow uppercase text-xs text-secondary mb-4">
            {t.about.eyebrow}
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
            {t.about.title}
          </h2>
        </div>
        <div className="md:col-span-6 md:col-start-7 space-y-6 self-center">
          <p className="text-base md:text-lg text-foreground leading-relaxed">
            {t.about.body1}
          </p>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            {t.about.body2}
          </p>
        </div>
      </div>
    </section>
  );
}
